/* Fliesenmänner – Cookie-/Consent-Banner
 *
 * Rechtlicher Rahmen: Art. 6/7 DSGVO + § 25 TDDDG.
 *  - Vor einer Entscheidung wird nichts Optionales freigeschaltet. Wir setzen
 *    NIE Consent auf "true", ohne dass jemand geklickt hat; der Default der
 *    Shopify Customer Privacy API (blockiert) bleibt stehen.
 *  - "Alle akzeptieren" und "Nur notwendige" sind gleichrangig (siehe CSS).
 *  - Die Entscheidung ist jederzeit widerrufbar (Art. 7 Abs. 3) über jedes
 *    Element mit [data-fm-consent-open] oder einen Link auf
 *    "#cookie-einstellungen".
 *
 * Kategorien -> Shopify Customer Privacy API:
 *    Notwendig  -> nichts zu setzen (immer erlaubt)
 *    Statistik  -> analytics
 *    Marketing  -> marketing + sale_of_data + preferences
 *  (preferences steckt bewusst bei Marketing: es deckt gemerkte Vorlieben zur
 *   Personalisierung ab und wird damit nie ohne Einwilligung aktiv.)
 *
 * Fällt dieses Skript aus, bleibt der Banner versteckt und es wird nichts
 * freigeschaltet — der Ausfall geht also in die datenschutzfreundliche
 * Richtung.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'fm_consent_v1';
  var COOKIE_MAX_AGE = 31536000; // 12 Monate
  var POLL_INTERVAL = 200;
  var POLL_TIMEOUT = 10000;

  var banner = document.querySelector('[data-fm-consent]');
  if (!banner) return;

  var designMode = banner.getAttribute('data-fm-consent-design-mode') === 'true';
  var detailsPanel = banner.querySelector('[data-fm-consent-details]');
  var toggleBtn = banner.querySelector('[data-fm-consent-toggle]');
  var gpcNote = banner.querySelector('[data-fm-consent-gpc]');
  var reopenBtn = document.querySelector('[data-fm-consent-reopen]');
  var boxAnalytics = banner.querySelector('[data-fm-consent-cat="analytics"]');
  var boxMarketing = banner.querySelector('[data-fm-consent-cat="marketing"]');

  // --- Speicher -----------------------------------------------------------
  // Erstanbieter-Cookie, 12 Monate. Das Speichern der Entscheidung selbst ist
  // nach § 25 Abs. 2 TDDDG unbedingt erforderlich und braucht keinen Consent.

  function readDecision() {
    try {
      var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));
      if (!match) return null;
      var data = JSON.parse(decodeURIComponent(match[1]));
      if (!data || data.v !== 1) return null;
      return { analytics: data.a === true, marketing: data.m === true };
    } catch (e) {
      return null;
    }
  }

  function writeDecision(decision) {
    try {
      var payload = JSON.stringify({
        v: 1,
        a: !!decision.analytics,
        m: !!decision.marketing,
        ts: Date.now()
      });
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie =
        COOKIE_NAME +
        '=' +
        encodeURIComponent(payload) +
        '; Max-Age=' +
        COOKIE_MAX_AGE +
        '; Path=/; SameSite=Lax' +
        secure;
    } catch (e) {
      /* Cookies gesperrt: Banner fragt beim nächsten Aufruf erneut. */
    }
  }

  // --- Shopify Customer Privacy API ---------------------------------------

  function toShopifyConsent(decision) {
    return {
      analytics: !!decision.analytics,
      marketing: !!decision.marketing,
      preferences: !!decision.marketing,
      sale_of_data: !!decision.marketing
    };
  }

  function privacyApi() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  var apiQueue = [];
  var apiReady = false;
  var apiFailed = false;

  function whenApiReady(fn) {
    if (apiFailed) return;
    if (apiReady && privacyApi()) {
      try {
        fn(privacyApi());
      } catch (e) {}
      return;
    }
    apiQueue.push(fn);
  }

  function flushApiQueue() {
    var api = privacyApi();
    if (!api) return;
    apiReady = true;
    var queued = apiQueue.slice();
    apiQueue.length = 0;
    queued.forEach(function (fn) {
      try {
        fn(api);
      } catch (e) {}
    });
  }

  function bootApi() {
    if (privacyApi()) {
      flushApiQueue();
      return;
    }
    // Offizieller Ladeweg; das Theme nutzt loadFeatures schon für model-viewer.
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      } catch (e) {}
    }
    var waited = 0;
    var timer = setInterval(function () {
      if (privacyApi()) {
        clearInterval(timer);
        flushApiQueue();
        return;
      }
      waited += POLL_INTERVAL;
      if (waited >= POLL_TIMEOUT) {
        clearInterval(timer);
        apiFailed = true;
        apiQueue.length = 0;
      }
    }, POLL_INTERVAL);
  }

  function pushConsent(api, decision) {
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    try {
      api.setTrackingConsent(toShopifyConsent(decision), function () {});
    } catch (e) {}
  }

  function applyConsent(decision) {
    whenApiReady(function (api) {
      pushConsent(api, decision);
    });
  }

  // Gespeicherte Entscheidung beim Seitenaufruf nachziehen — aber nur, wenn
  // Shopify sie noch nicht kennt, damit nicht jede Seite ein Consent-Event wirft.
  function syncStoredConsent(decision) {
    whenApiReady(function (api) {
      var wanted = toShopifyConsent(decision);
      var current = null;
      try {
        if (typeof api.currentVisitorConsent === 'function') current = api.currentVisitorConsent();
      } catch (e) {}
      if (current) {
        var same = true;
        for (var key in wanted) {
          if (!Object.prototype.hasOwnProperty.call(wanted, key)) continue;
          if (current[key] !== (wanted[key] ? 'yes' : 'no')) {
            same = false;
            break;
          }
        }
        if (same) return;
      }
      pushConsent(api, decision);
    });
  }

  // --- Oberfläche ---------------------------------------------------------

  function setBoxes(decision) {
    if (boxAnalytics) boxAnalytics.checked = !!decision.analytics;
    if (boxMarketing) boxMarketing.checked = !!decision.marketing;
  }

  function setDetails(open) {
    if (detailsPanel) detailsPanel.hidden = !open;
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function openBanner(moveFocus) {
    banner.hidden = false;
    if (reopenBtn) reopenBtn.hidden = true;
    if (moveFocus) {
      try {
        banner.focus({ preventScroll: true });
      } catch (e) {
        try {
          banner.focus();
        } catch (e2) {}
      }
    }
  }

  function closeBanner() {
    banner.hidden = true;
    setDetails(false);
    if (reopenBtn) reopenBtn.hidden = false;
  }

  var reopened = false;

  function decide(decision) {
    // Reihenfolge ist wichtig: erst speichern, dann an Shopify melden. Eine
    // nicht geladene API darf die Entscheidung nie verschlucken.
    writeDecision(decision);
    setBoxes(decision);
    applyConsent(decision);
    closeBanner();
    reopened = false;
    try {
      document.dispatchEvent(new CustomEvent('fm:consent', { detail: decision }));
    } catch (e) {}
  }

  function bind(selector, handler) {
    var el = banner.querySelector(selector);
    if (el) el.addEventListener('click', handler);
  }

  bind('[data-fm-consent-accept]', function () {
    decide({ analytics: true, marketing: true });
  });

  bind('[data-fm-consent-reject]', function () {
    decide({ analytics: false, marketing: false });
  });

  bind('[data-fm-consent-save]', function () {
    decide({
      analytics: !!(boxAnalytics && boxAnalytics.checked),
      marketing: !!(boxMarketing && boxMarketing.checked)
    });
  });

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      setDetails(toggleBtn.getAttribute('aria-expanded') !== 'true');
    });
  }

  // Widerruf: floating Knopf, beliebiges [data-fm-consent-open] und jeder Link
  // auf "#cookie-einstellungen" (so kann Clara im Theme-Editor einen
  // Footer-Menüpunkt anlegen, ohne dass jemand Code anfassen muss).
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('[data-fm-consent-open], a[href$="#cookie-einstellungen"]');
    if (!trigger) return;
    event.preventDefault();
    reopened = true;
    setBoxes(readDecision() || { analytics: false, marketing: false });
    openBanner(true);
    setDetails(true);
  });

  // Escape schließt nur, wenn bereits eine Entscheidung vorliegt. Beim ersten
  // Besuch darf der Banner nicht ungefragt verschwinden.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || banner.hidden) return;
    if (!reopened && !readDecision()) return;
    closeBanner();
  });

  // --- Start --------------------------------------------------------------

  bootApi();

  var stored = readDecision();
  var gpc = navigator.globalPrivacyControl === true;

  if (stored) {
    setBoxes(stored);
    syncStoredConsent(stored);
    closeBanner();
    // Im Theme-Editor immer zeigen, sonst sieht Clara ihre Textänderungen nicht.
    if (designMode) openBanner(false);
  } else {
    setBoxes({ analytics: false, marketing: false });
    if (gpc) {
      // Global Privacy Control ist ein Widerspruch: sofort wie "Nur notwendige"
      // behandeln, aber nichts speichern — die Person soll selbst entscheiden.
      applyConsent({ analytics: false, marketing: false });
      if (gpcNote) gpcNote.hidden = false;
    }
    // Nicht-modaler Banner: der Fokus wird beim Erscheinen bewusst NICHT
    // gestohlen. Erreichbar bleibt er per Tab, sichtbar per :focus-visible.
    openBanner(false);
  }

  window.fmConsent = {
    open: function () {
      reopened = true;
      setBoxes(readDecision() || { analytics: false, marketing: false });
      openBanner(true);
      setDetails(true);
    },
    get: readDecision
  };
})();
